// @ts-nocheck
import DatePicker, { DatePickerProps as BaseDatePickerProps } from "@insite/mobius/DatePicker";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import { getGridPreset } from "@toolkit/Framework/Common/Utilities/gridPreset";
import upperFirst from "lodash/upperFirst";
import React, { FC } from "react";
import { useTheme } from "styled-components";

type DatePickerProps = Omit<BaseDatePickerProps, "theme">;
const errorText = "This field is invalid.";

const Row: FC<DatePickerProps> = ({ label, ...props }) => {
    const minDate = new Date();
    minDate.setMonth(minDate.getMonth() - 1);

    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() + 1);

    const dateTimePickerProps = {
        minDate,
        maxDate,
    };

    return (
        <>
            <GridItem width={4}>
                <DatePicker label={label} dateTimePickerProps={dateTimePickerProps} {...props} />
            </GridItem>
            <GridItem width={4}>
                <DatePicker
                    label={`${label} (Disabled)`}
                    disabled
                    dateTimePickerProps={dateTimePickerProps}
                    {...props}
                />
            </GridItem>
            <GridItem width={4}>
                <DatePicker
                    label={`${label} (Error)`}
                    required
                    error={errorText}
                    dateTimePickerProps={dateTimePickerProps}
                    {...props}
                />
            </GridItem>
        </>
    );
};

const Variant: FC<DatePickerProps> = ({ sizeVariant }) => {
    const theme = useTheme();
    const gridContainerProps = getGridPreset(theme.design.form.grid.base);

    return (
        <StyleguideSection variant="h3" title={upperFirst(sizeVariant)}>
            <GridContainer {...gridContainerProps}>
                <Row label="Base" sizeVariant={sizeVariant} />
                <Row label="DateTime" format="MM/dd/yyyy hh:mm a" sizeVariant={sizeVariant} />
                <Row label="Value" sizeVariant={sizeVariant} selectedDay={new Date(Date.now())} />
                <GridItem width={4}>
                    <DatePicker label="Hint" sizeVariant={sizeVariant} hint="This is a field description." />
                </GridItem>
                <GridItem width={4}>
                    <DatePicker
                        label="Hint &amp; Error"
                        sizeVariant={sizeVariant}
                        hint="This is a field description."
                        error={errorText}
                    />
                </GridItem>
            </GridContainer>
        </StyleguideSection>
    );
};

const StyleguideDatePickers: FC = () => (
    <StyleguideSection title="Date Pickers">
        <Variant sizeVariant="default" />
        <Variant sizeVariant="small" />
        <Variant sizeVariant={"xsmall" as any} />
    </StyleguideSection>
);

export default StyleguideDatePickers;
